import { masterApi } from './api';

export default async function fetchBrandsData({ accessToken }) {
	const res = await masterApi.get('/GetProductBrands', {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	return res?.data?.data;
}
